import React, { useState } from 'react';
import { I18n as I } from 'react-redux-i18n';

import { Row, Col, Card, Typography, Statistic, Tooltip, Button } from 'antd';

import { formatDecimal, formatNumber, parseDecimal, parseNumber } from 'vdlib';
import UpgradeMembershipModal from 'components/bids/UpgradeMembershipModal';

import {
  TrophyOutlined,
  CalendarOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';

const { Paragraph } = Typography;

const cardStyle = {
  boxShadow:
    'rgba(0, 0, 0, 0.19) 0px 4px 10px, rgba(0, 0, 0, 0.23) 0px 4px 6px',
};

const PlacementComponent = ({ offerInfo, merchantFees, membershipID }) => {
  const formatAmount = obj => {
    var amount = parseDecimal(obj);
    var formattedAmount = formatDecimal(amount);
    return isNaN(amount) ? '' : '' + formattedAmount;
  };

  const [offerAmount, _setOfferAmount] = React.useState(
    offerInfo?.offerAmount || 0
  );
  const [feeTotalAmount, setFeeTotalAmount] = React.useState(
    offerInfo?.offerAmount || 0
  );

  React.useMemo(() => {
    var fee = merchantFees
      ? merchantFees.find(
          x =>
            offerAmount >= x.AmountFrom &&
            offerAmount < x.AmountTo &&
            x.MembershipID === membershipID
        )
      : 0;

    let feeAmount = 0;

    if (fee) {
      if (fee.FeePercentage) {
        feeAmount = (offerAmount * fee.FeePercentage) / 100;
      } else if (fee.FeeAmount) {
        feeAmount = fee.FeeAmount;
      }
    }

    setFeeTotalAmount(feeAmount);
  }, [offerAmount, merchantFees]);

  const [showUpgradeModal, setShowUpgradeModal] = React.useState(false);

  return (
    <div style={{ width: '100%' }}>
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Row gutter={[8, 8]}>
            {offerInfo && offerInfo.isGold ? (
              <Col xs={12} xxl={5}>
                <Card
                  style={{
                    backgroundColor:
                      offerInfo && offerInfo.offerPlacement === 1
                        ? '#daffd6'
                        : offerInfo && offerInfo.offerPlacement <= 3
                        ? '#eaf2b5'
                        : '#ffd6d6',
                    boxShadow:
                      'rgba(0, 0, 0, 0.19) 0px 4px 10px, rgba(0, 0, 0, 0.23) 0px 4px 6px',
                  }}
                >
                  <Statistic
                    title={I.t('OFFER_PLACEMENT')}
                    valueStyle={{ fontSize: 20 }}
                    value={offerInfo ? offerInfo.offerText : ''}
                    prefix={
                      <TrophyOutlined style={{ verticalAlign: '0.15em' }} />
                    }
                  />
                </Card>
              </Col>
            ) : null}
            {offerInfo &&
            !offerInfo.isGold &&
            offerInfo.offerPlacement === 1 ? (
              <Col xs={12} xxl={3}>
                <Card
                  style={{
                    backgroundColor:
                      offerInfo && offerInfo.offerPlacement === 1
                        ? '#daffd6'
                        : offerInfo && offerInfo.offerPlacement <= 3
                        ? '#eaf2b5'
                        : '#ffd6d6',
                    boxShadow:
                      'rgba(0, 0, 0, 0.19) 0px 4px 10px, rgba(0, 0, 0, 0.23) 0px 4px 6px',
                  }}
                >
                  <Statistic
                    title={I.t('OFFER_PLACEMENT')}
                    valueStyle={{ fontSize: 20 }}
                    value={offerInfo ? offerInfo.offerText : ''}
                    prefix={
                      <TrophyOutlined style={{ verticalAlign: '0.15em' }} />
                    }
                  />
                </Card>
              </Col>
            ) : offerInfo && membershipID === 99 ? (
              <Col xs={12} xxl={3}>
                <Card
                  style={{
                    backgroundColor:
                      offerInfo && offerInfo.offerPlacement === 1
                        ? '#daffd6'
                        : offerInfo && offerInfo.offerPlacement <= 3
                        ? '#eaf2b5'
                        : '#ffd6d6',
                    boxShadow:
                      'rgba(0, 0, 0, 0.19) 0px 4px 10px, rgba(0, 0, 0, 0.23) 0px 4px 6px',
                  }}
                >
                  <Statistic
                    title={I.t('OFFER_PLACEMENT')}
                    valueStyle={{ fontSize: 20 }}
                    value={
                      offerInfo && offerInfo.offerPlacement <= 3
                        ? offerInfo.offerText
                        : '< 3'
                    }
                    prefix={
                      <TrophyOutlined style={{ verticalAlign: '0.15em' }} />
                    }
                  />
                </Card>
              </Col>
            ) : null}
            <Col
              xs={12}
              xxl={
                offerInfo && offerInfo.isGold
                  ? 7
                  : offerInfo.offerPlacement === 1
                  ? 9
                  : 12
              }
            >
              <Card style={cardStyle}>
                <Statistic
                  title={I.t('OFFER')}
                  valueStyle={{ fontSize: 20 }}
                  value={offerInfo ? formatAmount(offerInfo.offerAmount) : 0}
                  prefix="€"
                />
              </Card>
            </Col>

            {offerInfo && offerInfo.offerPlacement === 1 ? (
              <>
                <Col xs={16} xxl={8}>
                  <Card style={cardStyle}>
                    <Statistic
                      title={I.t('OFFER_COMMITMENT_UNTIL')}
                      valueStyle={{ fontSize: 20 }}
                      value={offerInfo.offerDate}
                      prefix={
                        <CalendarOutlined style={{ verticalAlign: '0.15em' }} />
                      }
                    />
                  </Card>
                </Col>
                <Col xs={8} xxl={4}>
                  <Card style={cardStyle}>
                    <Statistic
                      title={I.t('FEE')}
                      valueStyle={{ fontSize: 20 }}
                      value={formatAmount(feeTotalAmount)}
                      prefix="€"
                    />
                  </Card>
                </Col>
              </>
            ) : offerInfo && offerInfo.isGold ? (
              <Col
                xs={
                  offerInfo.isGold && offerInfo.offerPlacement === 1 ? 12 : 24
                }
                xxl={12}
              >
                <Card style={cardStyle}>
                  <Statistic
                    title={I.t('BEST_OFFER')}
                    valueStyle={{ fontSize: 20 }}
                    value={formatAmount(offerInfo.offerBest)}
                    prefix="€"
                  />
                </Card>
              </Col>
            ) : offerInfo &&
              offerInfo.offerPlacement &&
              offerInfo.offerPlacement !== 1 &&
              !offerInfo.isGold &&
              membershipID !== 99 ? (
              <Col xs={12}>
                <Card style={cardStyle}>
                  <Tooltip title="search">
                    <Row justify="center">
                      <Button
                        icon={<InfoCircleOutlined style={{ fontSize: 20 }} />}
                        onClick={() => setShowUpgradeModal(true)}
                        style={{
                          margin: '12px 0px',
                          backgroundColor: '#EC636D',
                          color: '#fff',
                        }}
                      >
                        {I.t('PLACEMENT')}
                      </Button>
                    </Row>
                  </Tooltip>
                </Card>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <UpgradeMembershipModal
        show={showUpgradeModal}
        onHide={() => setShowUpgradeModal(false)}
        type="golden"
      />
    </div>
  );
};

export default PlacementComponent;
